import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entity } from '../../../../services/global/global-interfaces';

@Component({
  selector: 'app-location-attachments',
  templateUrl: './location-attachments.component.html',
  styleUrls: ['./location-attachments.component.scss'],
  standalone: false,
})
export class LocationAttachmentsComponent implements OnInit {
  locationId: number;
  entity: Entity;
  show: boolean;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      if (params.locationID) {
        this.locationId = +params.locationID;
        this.entity = {
          entity: 'location',
          entityId: this.locationId,
        };
        this.show = true;
      }
    });
  }
}
